import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../common/helpers/translate.helper';
import { IconFilter } from '../../../common/icons/cdl/Filter';
import { Box } from '../../../common/ui/Box';

export const AssignmentsEmptyState = () => {
    return (
        <Box display="flex" justifyContent="center" paddingTop="124px">
            <StatePlaceholder
                title={translate('assignments.noAssignmnents')}
                description={translate('assignments.tryDifferentFilter')}
                Icon={IconFilter}
            />
        </Box>
    );
};
